import i18n from '@/api/i18n/i18n';

export const COLUMNS_NOTIF = [
  {
    name: i18n.t('notif.columns.agent'),
    width: '8%',
    widthNum: 8,
    field: 'title',
    sort: 1,
    index: 0,
    filter: [],
    selected: [],
    showFilter: false,
  },
  {
    name: i18n.t('notif.columns.eventTime'),
    width: '8%',
    widthNum: 8,
    field: 'eventTime',
    sort: 0,
    index: 1,
    filter: [],
    selected: [],
    showFilter: false,
  },
  {
    name: i18n.t('notif.columns.reason'),
    width: '15%',
    widthNum: 15,
    field: 'reasonString',
    sort: 0,
    index: 2,
    filter: [],
    selected: [],
    showFilter: false,
  },
  {
    name: i18n.t('notif.columns.category'),
    width: '8%',
    widthNum: 8,
    field: 'categoryName',
    sort: 0,
    index: 3,
    filter: [],
    selected: [],
    showFilter: false,
  },
  {
    name: i18n.t('notif.columns.controller'),
    width: '8%',
    widthNum: 8,
    field: 'checkUser',
    sort: 0,
    index: 4,
    filter: [],
    selected: [],
    showFilter: false,
  },
  {
    name: i18n.t('notif.columns.checkTime'),
    width: '10%',
    widthNum: 10,
    field: 'checkTime',
    sort: 0,
    index: 5,
    filter: [],
    selected: [],
    showFilter: false,
  },
  {
    name: i18n.t('notif.columns.description'),
    width: '20%',
    widthNum: 20,
    field: 'descriptionOutput',
    sort: 0,
    index: 6,
    filter: [],
    selected: [],
    showFilter: false,
  },
  {
    name: i18n.t('notif.columns.keywords'),
    width: '8%',
    widthNum: 8,
    field: 'keywords',
    sort: 0,
    index: 7,
    filter: [],
    selected: [],
    showFilter: false,
  },
];

export const COLUMNS_SYS_LOGS = [
  {
    name: i18n.t('notif.columns.eventTime'),
    width: '8%',
    widthNum: 8,
    field: 'eventTime',
    sort: 1,
    index: 0,
    filter: [],
    selected: [],
    showFilter: false,
  },
  {
    name: i18n.t('notif.columns.eventTypeName'),
    width: '8%',
    widthNum: 8,
    field: 'eventTypeName',
    sort: 0,
    index: 1,
    filter: [],
    selected: [],
    showFilter: false,
  },
  {
    name: i18n.t('notif.columns.comment'),
    width: '8%',
    widthNum: 8,
    field: 'comment',
    sort: 0,
    index: 2,
    filter: [],
    selected: [],
    showFilter: false,
  },

  {
    name: i18n.t('notif.columns.controller'),
    width: '8%',
    widthNum: 8,
    field: 'contrName',
    sort: 0,
    index: 3,
    filter: [],
    selected: [],
    showFilter: false,
  },
  {
    name: i18n.t('notif.columns.critLevel'),
    width: '8%',
    widthNum: 8,
    field: 'critLevelText',
    sort: 0,
    index: 4,
    filter: [],
    selected: [],
    showFilter: false,
  },
];

export const groupFieldMap = {
  eventTypeName: 'eventTypeId',
  reasonString: 'reasonId',
  categoryName: 'categoryId',
};
